import { FC } from "react";
import { INoAccessToFeatureProps } from "./types";
import Unauthenticated from "./unauthenticated";
import MissingAccess from "./missingAccess";

const NoAccessToFeature: FC<INoAccessToFeatureProps> = ({ session }) => {
  if (session?.status === "unauthenticated") {
    return <Unauthenticated />;
  }

  return <MissingAccess />;
};

export default NoAccessToFeature;
